import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { parse, Renderer } from 'marked';

@Injectable()
export class MarkdownService {
  private renderer = new Renderer()
  private options = {
    gfm: true,
    renderer: this.renderer,
    tables: true,
  }

  constructor(private sanitizer: DomSanitizer) {}

  render(markdown = ''): string {
    return this.sanitizer.sanitize(
      SecurityContext.HTML,
      parse(markdown, this.options)
    );
  }

  plaintext(markdown = ''): string {
    const div = document.createElement('div');
    div.innerHTML = this.render(markdown);
    return div.innerText;
  }
}
